import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { AlertModalService } from "./alert-modal.service";
import { ConfirmationModalService } from "./confirmation-modal.service";
import { ModalService } from "./modal.service";

@NgModule({
  imports: [CommonModule],
  providers: [AlertModalService, ConfirmationModalService, ModalService]
})
export class ModalsModule {}
